import { Schema, get } from '../../../json-transform';

export const isoQS = new Schema({
  multiface_policy: get('multiface_policy').asInt(),
  image_type: get('image_type').asInt(),
});
